export default (() => ({
  colour: {
    priceFinderNavy400: '#22365a',
    priceFinderNavy500: '#0b2047',
    priceFinderNavy600: '#071939',
    priceFinderGreen25: '#f3faf2',
    priceFinderGreen50: '#f0f8f7',
    priceFinderGreen100: '#c8e8e4',
    priceFinderGreen200: '#9fd7d1',
    priceFinderGreen300: '#74c6be',
    priceFinderGreen400: '#3db5ac',
    priceFinderGreen500: '#0f9991',
    priceFinderGreen600: '#1a746e',
    priceFinderGreen700: '#1a514d',
    priceFinderGreen800: '#0a1312',
    priceFinderLobster100: '#ffcec3',
    priceFinderLobster500: '#ff613d',
    priceFinderLobster600: '#f74a23',
    priceFinderCanary500: '#fc0',
    priceFinderCanary100: '#ffefaf',
    priceFinderTurquoise500: '#05bbb6',
    priceFinderTurquoise100: '#ccf1f0',
    priceFinderGrimace500: '#612b87',
    priceFinderBlurple500: '#514aea'
  }
}));